import React from 'react';
export function FooterSection() {
  return <footer className="bg-navy-950 py-12 border-t border-navy-800" data-id="element-112">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-113">
        <div className="text-2xl font-display text-offwhite tracking-wider mb-4" data-id="element-114">
          🏓 DOMINIO TOTAL
        </div>

        <p className="text-text-secondary text-sm max-w-md mb-8" data-id="element-115">
          El sistema de entrenamiento N°1 para jugadores en Argentina. Porque
          subir de nivel y ganar más partidos no debería costarte frustración ni
          dinero mal gastado en equipo.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-xs text-text-secondary/60 mb-8" data-id="element-116">
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-117">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-118">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-119">
            Contacto
          </a>
        </div>

        <p className="text-xs text-text-secondary/40" data-id="element-120">
          © {new Date().getFullYear()} Dominio Total. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}